import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import BrandProvider from "@/context/BrandContext";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/layout/SiteLayout";
import SeoHead from "@/components/SeoHead";
import Home from "@/pages/Home";
import MealsPage from "@/pages/MealsPage";
import PlansPage from "@/pages/PlansPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import FoodStandardsPage from "@/pages/FoodStandardsPage";
import OurStoryPage from "@/pages/OurStoryPage";
import SupportingMothersPage from "@/pages/SupportingMothersPage";
import FaqsPage from "@/pages/FaqsPage";
import ContactPage from "@/pages/ContactPage";
import EarlyAccessPage from "@/pages/EarlyAccessPage";
import DeliveryAreasPage from "@/pages/DeliveryAreasPage";
import SignInPage from "@/pages/SignInPage";
import AccountPage from "@/pages/AccountPage";
import CheckoutPage from "@/pages/CheckoutPage";
import LegalPage from "@/pages/LegalPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <SeoHead />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/meals" element={<MealsPage />} />
          <Route path="/menu" element={<Navigate to="/meals?tab=week-1" replace />} />
          <Route path="/breakfast" element={<Navigate to="/meals?tab=breakfast" replace />} />
          <Route path="/plans" element={<PlansPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/food-standards" element={<FoodStandardsPage />} />
          <Route path="/our-story" element={<OurStoryPage />} />
          <Route path="/mothers-supporting-mothers" element={<SupportingMothersPage />} />
          <Route path="/faqs" element={<FaqsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/get-started" element={<EarlyAccessPage />} />
          <Route path="/early-access" element={<Navigate to="/get-started" replace />} />
          <Route path="/delivery-areas" element={<DeliveryAreasPage />} />
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrandProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </BrandProvider>
  );
}
